import React, { useRef, useState } from 'react';
import '../../../styles/components/management/Rota/FiltersBar.css';

export default function FiltersBar({
  properties, users,
  selectedProperty, setSelectedProperty,
  selectedUser, setSelectedUser,
  dateRange, setDateRange,
  currentMonth, setCurrentMonth,
  reload
}) {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  const handleMonthNav = (direction) => {
    const newStart = new Date(dateRange.start);
    newStart.setMonth(newStart.getMonth() + (direction === 'next' ? 1 : -1));
    const newEnd = new Date(newStart);
    newEnd.setMonth(newStart.getMonth() + 1);

    setDateRange({
      start: newStart.toISOString().slice(0, 10),
      end: newEnd.toISOString().slice(0, 10),
    });

    setCurrentMonth(newStart.toLocaleString('default', {
      month: 'long',
      year: 'numeric',
    }));
  };

  
  


  return (
    <div className="filters-bar-wrapper">
      <div className="filters-header">
        <button className="filters-toggle" onClick={() => setIsOpen(!isOpen)}>
          Filters {isOpen ? '▲' : '▼'}
        </button>
        <button className="print-button" onClick={() => window.print()}>🖨️ Print This View</button>
      </div>

      <div
        className={`filters-content ${isOpen ? 'open' : ''}`}
        ref={contentRef}
        style={{ maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : '0px' }}
      >
        <select value={selectedProperty} onChange={e => setSelectedProperty(e.target.value)}>
          <option value="all">All Properties</option>
          {properties.map(p => (
            <option key={`property-${p.PROPERTY_ID}`} value={p.PROPERTY_ID}>
              {p.PROPERTY_NAME}
            </option>
          ))}
        </select>

        {users?.length > 0 && (
          <select value={selectedUser} onChange={e => setSelectedUser(e.target.value)}>
            <option value="">All Users</option>
            {users.map(u => (
              <option key={`user-${u.USER_ID}`} value={u.USER_ID}>
                {u.USER_NAME}
              </option>
            ))}
          </select>
        )}

        <input
          type="date"
          value={dateRange.start}
          onChange={e => setDateRange({ ...dateRange, start: e.target.value })}
        />
        <input
          type="date"
          value={dateRange.end}
          onChange={e => setDateRange({ ...dateRange, end: e.target.value })}
        />
      </div>

      <div className="filters-footer">
        <button onClick={() => handleMonthNav('prev')}>← Prev</button>
        <button onClick={reload}>Reload</button>
        <button onClick={() => handleMonthNav('next')}>Next →</button>
      </div>
    </div>
  );
}
